import React from "react";

import { Search } from "@mui/icons-material";
import {
  TableRow,
  TableCell,
  Box,
  Typography,
  Paper,
  InputBase,
  IconButton,
} from "@mui/material";

interface SearchSectionProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

export const SearchSection: React.FC<SearchSectionProps> = ({
  searchTerm,
  onSearchChange,
}) => {
  return (
    <TableRow>
      <TableCell
        colSpan={5}
        sx={{
          backgroundColor: "action.hover",
          fontWeight: "bold",
          borderTop: "2px solid",
          borderColor: "divider",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Search Groups
          </Typography>
          <Paper
            component="div"
            sx={{
              p: "4px 8px",
              display: "flex",
              alignItems: "center",
              minWidth: 300,
              backgroundColor: "background.paper",
              border: 1,
              borderColor: "divider",
              borderRadius: 1,
              "&:focus-within": {
                borderColor: "primary.main",
                boxShadow: (theme) =>
                  `0 0 0 2px ${theme.palette.primary.main}25`,
              },
            }}
          >
            <IconButton
              sx={{ p: "4px", color: "text.secondary" }}
              aria-label="search"
              size="small"
            >
              <Search fontSize="small" />
            </IconButton>
            <InputBase
              sx={{
                ml: 1,
                flex: 1,
                fontSize: "14px",
              }}
              placeholder="Search by group name or agency..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              inputProps={{ "aria-label": "search groups" }}
            />
          </Paper>
        </Box>
      </TableCell>
    </TableRow>
  );
};
